import React from "react";
import '../../App.css'
import TShirtFromCard from "../TShirtFormCard";
import Footer from "../Footer";
import Roots from "../Roots";
export default function TShirtFrom(){
    return (
        <>
            <TShirtFromCard />
            <Roots />
        </>

    )
}